<template>
  <div
    :class="{ 'q-px-md': $kiosk }"
    data-test-id="explore-movies"
  >
    <section-heading
      v-if="title"
      :heading-color="headingColor"
      :heading-color-hex="headingColorHex"
      :heading-font-size="headingFontSize"
      :heading-align="headingAlign"
      :heading-type="headingType"
      :heading-background-image-url="headingBackgroundImageUrl"
      :heading-background-image-repeat="headingBackgroundImageRepeat"
      :title="title"
      :is-mobile-view="isMobileView"
      :light-text="exploreUsingDarkMode"
      class="container"
    />
    <div
      v-if="movies.loaded"
      class="q-pt-xs"
    >
      <div
        v-if="showSearch || showType"
        class="row items-center justify-center q-mt-md container relative-position no-padding overflow-hidden"
        :style="{
          'border-radius': `${posterBorderRadius}px`,
          'border': showSearch || showType ? '1px solid' : undefined,
          'border-color': exploreUsingDarkMode ? 'white' : '#ccc',
        }"
        :class="isMobileView ? 'q-mb-xs' : 'q-mb-md'"
      >
        <q-input
          v-if="showSearch"
          ref="search"
          v-model="search"
          :label="$t('search.for.titleGenreActorDate')"
          dense
          filled
          bg-color="transparent"
          class="col"
          :dark="exploreUsingDarkMode"
          clearable
          :style="{
            width: isMobileView ? '150px' : '',
            'border-right-width': showType ? '1px' : '0px',
            'border-right-style': showType ? 'solid' : 'solid',
            'border-right-color': exploreUsingDarkMode ? 'white' : '#ccc'
          }"
        >
          <template #prepend>
            <q-icon
              name="search"
              color="responsive"
            />
          </template>
        </q-input>
        <template v-if="showType">
          <q-tabs
            v-if="!isMobileView"
            v-model="type"
            dense
            no-caps
            class="q-pa-xs q-gutter-sm size-md"
            :class="{
              'text-white': exploreUsingDarkMode,
              'col-auto': showSearch,
              'col': !showSearch
            }"
            :active-color="getTextColor(currentSite.primaryColor)"
            active-bg-color="primary"
            indicator-color="transparent"
            align="justify"
            @update:model-value="selectedTitleClassId = null; titleClassTabs = null"
          >
            <q-tab
              v-if="exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.NOW_PLAYING]"
              :key="EXPLORE_MOVIES_FILTER_TYPES.NOW_PLAYING"
              :name="MOVIE_QUERY_TYPE.NOW_PLAYING"
              :label="$t('movie.nowPlaying')"
              :style="{ 'border-radius': `${posterBorderRadius}px` }"
            />

            <q-tab
              v-if="exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.COMING_SOON]"
              :key="EXPLORE_MOVIES_FILTER_TYPES.COMING_SOON"
              :name="MOVIE_QUERY_TYPE.COMING_SOON"
              :label="$t('movie.comingSoon')"
              :style="{ 'border-radius': `${posterBorderRadius}px` }"
            />
            <q-tab
              v-if="exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.ALL_MOVIES]"
              :key="EXPLORE_MOVIES_FILTER_TYPES.ALL_MOVIES"
              :name="MOVIE_QUERY_TYPE.NOW_PLAYING_AND_COMING_SOON"
              :label="$t('collection.all')"
              :style="{ 'border-radius': `${posterBorderRadius}px` }"
            />
            <q-tab
              v-if="exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.MY_MOVIES]"
              :key="EXPLORE_MOVIES_FILTER_TYPES.MY_MOVIES"
              :name="MOVIE_QUERY_TYPE.MY_LISTS "
              :label="$t('movie.myMovies')"
              :style="{ 'border-radius': `${posterBorderRadius}px` }"
            />
          </q-tabs>
          <q-select
            v-else
            v-model="type"
            dense
            no-caps
            :options="exploreMoviesFilterOptions"
            :class="showSearch ? 'col-auto' : 'col'"
            filled
            bg-color="transparent"
            :dark="exploreUsingDarkMode"
            map-options
            emit-value
            @update:model-value="selectedTitleClassId = null; titleClassTabs = null"
          />
        </template>
      </div>
      <div
        v-if="type === MOVIE_QUERY_TYPE.MY_LISTS || (useClassFilter && titleClassTabs) || showDisplayType"
        class="row container q-py-none relative-position"
        style="padding: 0;"
        :class="isMobileView ? 'justify-end q-my-xs' : ' justify-between q-my-sm'"
      >
        <div
          v-if="type === MOVIE_QUERY_TYPE.MY_LISTS || !isMobileView"
          :class="{
            'full-width': isMobileView,
            'col q-mr-sm': !isMobileView
          }"
        >
          <q-tabs
            v-if="type === MOVIE_QUERY_TYPE.MY_LISTS "
            v-model="userList"
            :dense="isMobileView"
            no-caps
            mobile-arrows
            :inline-label="!isMobileView"
            class="size-md"
            :class="{
              'q-my-xs': $q.screen.lt.md || isPhonePreview,
              'q-my-none col-auto': !$q.screen.lt.md && !isPhonePreview,
              'text-white': exploreUsingDarkMode,
              'text-secondary': !exploreUsingDarkMode
            }"
            active-color="primary"
            indicator-color="primary"
            align="left"
          >
            <q-tab
              :key="'Watched'"
              :name="'watched'"
              :label="$t('actions.watched')"
              icon="visibility"
              class="q-mr-xs"
            />
            <q-tab
              :key="'watch-list'"
              :name="'watch_list'"
              :label="$t('user.watchList')"
              icon="bookmark"
              class="q-mr-xs"
            />
            <q-tab
              :key="'Favorited'"
              :name="'favorite'"
              :label="$t('actions.favorited')"
              icon="ion-heart"
              class="q-mr-xs"
            />
            <q-tab
              :key="'Rated'"
              :name="'rating'"
              :label="$t('movie.actions.rated')"
              icon="star"
              class="q-mr-xs"
            />
          </q-tabs>
          <q-tabs
            v-if="useClassFilter && titleClassTabs && type !== MOVIE_QUERY_TYPE.MY_LISTS && !isMobileView"
            v-model="selectedTitleClassId"
            dense
            no-caps
            mobile-arrows
            class="col-auto size-md"
            :class="{
              'q-my-sm': $q.screen.lt.md || isPhonePreview,
              'q-my-none': !$q.screen.lt.md && !isPhonePreview,
              'text-white': exploreUsingDarkMode,
              'text-grey-7': !exploreUsingDarkMode
            }"
            :active-color="getTextColor(currentSite.primaryColor)"
            active-bg-color="primary"
            indicator-color="transparent"
            align="left"
          >
            <q-tab
              :key="'All'"
              :name="null"
              :label="$t('collection.all')"
              style="border: 1px solid;"
              :style="{ 'border-radius': `${posterBorderRadius}px` }"
              class="q-mr-xs"
            />
            <q-tab
              v-for="titleClass in titleClassTabs"
              :key="titleClass.name"
              :name="titleClass.id"
              :label="titleClass.name"
              style="border: 1px solid;"
              :style="{ 'border-radius': `${posterBorderRadius}px` }"
              class="q-mr-xs"
            />
          </q-tabs>
        </div>
        <div
          class="row justify-end"
          :class="isMobileView ? 'full-width q-my-sm' : 'col-auto'"
        >
          <q-select
            v-if="useClassFilter && titleClassTabs && isMobileView"
            v-model="selectedTitleClassId"
            :options="titleClassTabs"
            :style="'border-radius: ' + posterBorderRadius + 'px;'"
            :dark="exploreUsingDarkMode"
            class="col"
            option-label="name"
            option-value="id"
            :label="$t('search.actions.filterBy')"
            filled
            :stack-label="false"
            emit-value
            map-options
            clearable
            dense
          />
          <q-select
            v-if="showDisplayType"
            v-model="displayType"
            :label="$t('nav.actions.view')"
            dense
            :options="[{ label: $tc('movie.poster', 2), value: 'posters' },
                       { label: $t('movie.releaseDate'), value: 'calendar' },
                       { label: $t('showing.showingsCalendar'), value: 'showings-calendar' },
                       { label: $t('search.alphabetical'), value: 'alphabetical' }]"
            popup-content-class="text-capitalize"
            class="col-auto text-capitalize text-caption"
            filled
            bg-color="transparent"
            :dark="exploreUsingDarkMode"
            map-options
            emit-value
          />
          <q-btn
            v-if="showDisplayType && displayType === 'calendar'"
            icon="swap_vert"
            color="transparent"
            unelevated
            text-color="grey"
            size="sm"
            padding="sm"
            @click="calendarViewDescend = !calendarViewDescend"
          />
        </div>
      </div>
      <q-banner
        v-if="type === MOVIE_QUERY_TYPE.MY_LISTS && myListDescriptions[userList]"
        class="q-my-xs text-grey-6 text-center text-subtitle1 bg-transparent full-width"
        style="box-shadow:  0 7px 9px -7px rgba(0, 0, 0, 0.2) inset; margin-top: -10px"
      >
        {{ myListDescriptions[userList] }}
      </q-banner>
      <div
        v-if="useClassFilter && titleClassTabs && type === MOVIE_QUERY_TYPE.MY_LISTS && !isMobileView"
        class="row container q-my-sm q-py-none relative-position justify-between"
        style="padding: 0"
      >
        <q-tabs
          v-model="selectedTitleClassId"
          dense
          no-caps
          outside-arrows
          mobile-arrows
          class="col-auto q-my-none size-md"
          :class="{ 'text-white': exploreUsingDarkMode, 'text-grey-7': !exploreUsingDarkMode }"
          active-color="white"
          active-bg-color="primary"
          indicator-color="transparent"
          align="left"
          padding="none"
        >
          <q-tab
            :key="'All'"
            :name="null"
            :label="$t('collection.all')"
            style="border: 1px solid; width: auto;"
            :style="{ 'border-radius': `${posterBorderRadius}px` }"
            class="q-mr-xs"
          />
          <q-tab
            v-for="titleClass in titleClassTabs"
            :key="titleClass.name"
            :name="titleClass.id"
            :label="titleClass.name"
            style="border: 1px solid; width: auto;"
            :style="{ 'border-radius': `${posterBorderRadius}px` }"
            class="q-mr-xs"
          />
        </q-tabs>
      </div>
      <div
        v-if="type === 'future-movies'"
        class="q-my-xs q-mx-md text-responsive-grey-6 text-center text-subtitle2"
      >
        {{ $t('pages.exploreMovies.unconfirmedMoviesDisclaimer') }}
      </div>

      <div
        v-if="!movies.loaded"
        class="row justify-center"
      >
        <q-spinner
          size="md"
          color="grey"
        />
      </div>

      <div
        v-else
        class="main-display"
      >
        <transition-group
          v-if="displayType === 'posters'"
          name="list-complete"
          class="row full-width content-stretch"
          tag="span"
        >
          <div
            v-for="movie in movieQuery"
            :key="movie.id"
            class="cursor-pointer list-complete-item"
            :class="{
              [movie.displayMetaData && movie.displayMetaData.classes]: true,
              'col': isMobileView
            }"
            :style="{
              'min-width': setWidth(movie, minWidth),
              'width': setWidth(movie, minWidth),
              padding: posterPadding + 'px'
            }"
          >
            <explore-poster
              :movie="movie"
              :border-radius="posterBorderRadius"
              :shadow="shadow"
              :show-trailer-button-on-posters="showTrailerButtonOnPosters"
              :clean-image-on-posters="cleanImageOnPosters"
              :use-banner="useBanner || isFeatured(movie)"
              :explore-using-dark-mode="exploreUsingDarkMode"
              :show-movie-title-on-posters="showMovieTitleOnPosters"
              :show-movie-rating="showMovieRating"
              :show-movie-genre="showMovieGenre"
              :font-size="fontSize"
              :has-text-wrapped="hasTextWrapped"
              :has-text-centred="hasTextCentred"
              :show-movie-showing-status-on-posters="showMovieShowingStatusOnPosters"
              :width-mode="widthMode"
              :show-user-buttons="showUserButtons"
              :show-title-class="showTitleClass"
              :poster-background-color="posterBackgroundColor"
              :poster-background-color-hex="posterBackgroundColorHex"
              :poster-featured-background-color="posterFeaturedBackgroundColor"
              :poster-featured-background-color-hex="posterFeaturedBackgroundColorHex"
              :is-featured="isFeatured(movie)"
              :has-featured-title-class="hasFeaturedTitleClass(movie)"
              :featured-showing-badges="featuredShowingBadges(movie)"
              :poster-padding="posterPadding"

              :show-movie-synopsis="showMovieSynopsis"
              :truncated-movie-synopsis="truncatedMovieSynopsis"
              :truncated-line-count="truncatedLineCount"
              :mobile-truncated-line-count="mobileTruncatedLineCount"
              :show-coming-soon-date="showComingSoonDate"
              :show-release-date="showReleaseDate"

              :button-label="buttonLabel"
              :button-type="buttonType"
              :button-color="buttonColor"
              :button-color-hex="buttonColorHex"
              :button-border-radius="buttonBorderRadius"

              :is-phone-preview="isPhonePreview"
              :is-mobile-view="isPhonePreview || $q.screen.lt.sm"
            />
          </div>
        </transition-group>

        <div
          v-if="displayType === 'calendar'"
          class="column full-width content-stretch no-wrap"
        >
          <div
            v-for="firstShowingDate in firstShowingDates"
            :key="firstShowingDate.toString()"
            class="row group-section"
          >
            <div
              v-if="firstShowingDate === $t('common.TBC')"
              class="col-2 col-sm-1 column justify-center text-center"
            >
              <div
                class="text-overline"
                style="font-size: 18px;"
                :class="exploreUsingDarkMode ? 'text-white' : 'text-dark'"
              >
                {{ firstShowingDate }}
              </div>
            </div>
            <div
              v-else
              class="col-2 col-sm-1 column justify-center text-center"
              :class="exploreUsingDarkMode ? 'text-white' : 'text-dark'"
            >
              <div
                class="text-subtitle1"
              >
                {{ formatDate(firstShowingDate, 'ddd') }}
              </div>
              <div
                class="text-overline"
                style="font-size: 18px;"
              >
                {{ formatDate(firstShowingDate, 'MMM') }}
              </div>
              <div
                class="text-h6"
                style="font-size: 18px;"
              >
                {{ formatDate(firstShowingDate, 'Do') }}
              </div>
              <div
                class="text-subtitle1"
              >
                {{ formatDate(firstShowingDate, 'YYYY') }}
              </div>
            </div>
            <div
              v-dragscroll.pass="!$q.platform.has.touch"
              class="col row no-wrap overflow-hidden-y scroll-x"
              @dragscrollstart="setDragging(true)"
              @dragscrollend="setDragging(false)"
            >
              <div
                v-for="movie in moviesByDateOfFirstShowing[firstShowingDate]"
                :key="movie.id"
                class="cursor-pointer"
                :style="{
                  'min-width': setWidth(movie, minWidth),
                  'width': setWidth(movie, minWidth),
                  padding: posterPadding + 'px'
                }"
              >
                <explore-poster
                  :movie="movie"
                  :use-banner="useBanner || isFeatured(movie)"
                  :dragging="dragging"
                  :border-radius="posterBorderRadius"
                  :shadow="shadow"
                  :show-trailer-button-on-posters="showTrailerButtonOnPosters"
                  :clean-image-on-posters="cleanImageOnPosters"
                  :explore-using-dark-mode="exploreUsingDarkMode"
                  :show-movie-title-on-posters="showMovieTitleOnPosters"
                  :show-movie-rating="showMovieRating"
                  :show-movie-genre="showMovieGenre"
                  :font-size="fontSize"
                  :has-text-wrapped="hasTextWrapped"
                  :has-text-centred="hasTextCentred"
                  :show-movie-showing-status-on-posters="showMovieShowingStatusOnPosters"
                  :width-mode="widthMode"
                  :show-user-buttons="showUserButtons"
                  :show-title-class="showTitleClass"
                  :poster-background-color="posterBackgroundColor"
                  :poster-background-color-hex="posterBackgroundColorHex"
                  :poster-featured-background-color="posterFeaturedBackgroundColor"
                  :poster-featured-background-color-hex="posterFeaturedBackgroundColorHex"
                  :is-featured="isFeatured(movie)"
                  :has-featured-title-class="hasFeaturedTitleClass(movie)"
                  :featured-showing-badges="featuredShowingBadges(movie)"

                  :show-movie-synopsis="showMovieSynopsis"
                  :truncated-movie-synopsis="truncatedMovieSynopsis"
                  :truncated-line-count="truncatedLineCount"
                  :mobile-truncated-line-count="mobileTruncatedLineCount"
                  :show-coming-soon-date="showComingSoonDate"
                  :show-release-date="showReleaseDate"

                  :button-label="buttonLabel"
                  :button-type="buttonType"
                  :button-color="buttonColor"
                  :button-color-hex="buttonColorHex"
                  :button-border-radius="buttonBorderRadius"

                  :is-phone-preview="isPhonePreview"
                  :is-mobile-view="isPhonePreview || $q.screen.lt.sm"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="displayType === 'showings-calendar'"
          class="column full-width content-stretch no-wrap"
        >
          <div
            v-for="showingDate in showingDates"
            :key="showingDate.toString()"
            class="row group-section"
          >
            <div
              class="col-2 col-sm-1 column justify-center text-center"
              :class="exploreUsingDarkMode ? 'text-white' : 'text-dark'"
            >
              <div
                class="text-subtitle1"
              >
                {{ $d(showingDate, 'weekday') }}
              </div>
              <div
                class="text-overline"
                style="font-size: 18px;"
              >
                {{ $d(showingDate, 'month') }}
              </div>
              <div
                class="text-h6"
                style="font-size: 18px;"
              >
                {{ $d(showingDate, 'day') }}
              </div>
              <div
                class="text-subtitle1"
              >
                {{ $d(showingDate, 'year') }}
              </div>
            </div>
            <div
              v-dragscroll.pass="!$q.platform.has.touch"
              class="col row no-wrap overflow-hidden-y scroll-x"
              @dragscrollstart="setDragging(true)"
              @dragscrollend="setDragging(false)"
            >
              <div
                v-for="movie in moviesByShowingDate[showingDate]"
                :key="movie.id"
                class="cursor-pointer"
                :style="{
                  'min-width': setWidth(movie, minWidth),
                  'width': setWidth(movie, minWidth),
                  padding: posterPadding + 'px'
                }"
              >
                <explore-poster
                  :movie="movie"
                  :date="showingDate"
                  :use-banner="useBanner || isFeatured(movie)"
                  :dragging="dragging"
                  :border-radius="posterBorderRadius"
                  :shadow="shadow"
                  :show-trailer-button-on-posters="showTrailerButtonOnPosters"
                  :clean-image-on-posters="cleanImageOnPosters"
                  :explore-using-dark-mode="exploreUsingDarkMode"
                  :show-movie-title-on-posters="showMovieTitleOnPosters"
                  :show-movie-rating="showMovieRating"
                  :show-movie-genre="showMovieGenre"
                  :font-size="fontSize"
                  :has-text-wrapped="hasTextWrapped"
                  :has-text-centred="hasTextCentred"
                  :show-movie-showing-status-on-posters="showMovieShowingStatusOnPosters"
                  :width-mode="widthMode"
                  :show-user-buttons="showUserButtons"
                  :show-title-class="showTitleClass"
                  :poster-background-color="posterBackgroundColor"
                  :poster-background-color-hex="posterBackgroundColorHex"
                  :poster-featured-background-color="posterFeaturedBackgroundColor"
                  :poster-featured-background-color-hex="posterFeaturedBackgroundColorHex"
                  :is-featured="isFeatured(movie)"
                  :has-featured-title-class="hasFeaturedTitleClass(movie)"
                  :featured-showing-badges="featuredShowingBadges(movie)"

                  :show-movie-synopsis="showMovieSynopsis"
                  :truncated-movie-synopsis="truncatedMovieSynopsis"
                  :truncated-line-count="truncatedLineCount"
                  :mobile-truncated-line-count="mobileTruncatedLineCount"
                  :show-coming-soon-date="showComingSoonDate"
                  :show-release-date="showReleaseDate"
                  :button-label="buttonLabel"
                  :button-type="buttonType"
                  :button-color="buttonColor"
                  :button-color-hex="buttonColorHex"
                  :button-border-radius="buttonBorderRadius"

                  :is-phone-preview="isPhonePreview"
                  :is-mobile-view="isPhonePreview || $q.screen.lt.sm"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="displayType === 'alphabetical'"
          class="column full-width content-stretch no-wrap"
        >
          <div
            v-for="firstLetter in firstLetters"
            :key="firstLetter"
            class="row group-section"
          >
            <div
              class="col-2 col-sm-1 column justify-center text-center"
            >
              <div
                class="text-h4"
                :class="exploreUsingDarkMode ? 'text-white' : 'text-dark'"
              >
                {{ firstLetter }}
              </div>
            </div>
            <div
              v-dragscroll.pass="!$q.platform.has.touch"
              class="col row no-wrap overflow-hidden-y scroll-x"
              @dragscrollstart="setDragging(true)"
              @dragscrollend="setDragging(false)"
            >
              <div
                v-for="movie in moviesByFirstLetter[firstLetter]"
                :key="movie.id"
                class="cursor-pointer"
                :style="{
                  'min-width': setWidth(movie, minWidth),
                  'width': setWidth(movie, minWidth),
                  padding: posterPadding + 'px'
                }"
              >
                <explore-poster
                  :movie="movie"
                  :use-banner="useBanner || isFeatured(movie)"
                  :dragging="dragging"
                  :border-radius="posterBorderRadius"
                  :shadow="shadow"
                  :show-trailer-button-on-posters="showTrailerButtonOnPosters"
                  :clean-image-on-posters="cleanImageOnPosters"
                  :explore-using-dark-mode="exploreUsingDarkMode"
                  :show-movie-title-on-posters="showMovieTitleOnPosters"
                  :show-movie-rating="showMovieRating"
                  :show-movie-genre="showMovieGenre"
                  :font-size="fontSize"
                  :has-text-wrapped="hasTextWrapped"
                  :has-text-centred="hasTextCentred"
                  :show-movie-showing-status-on-posters="showMovieShowingStatusOnPosters"
                  :width-mode="widthMode"
                  :show-user-buttons="showUserButtons"
                  :show-title-class="showTitleClass"
                  :poster-background-color="posterBackgroundColor"
                  :poster-background-color-hex="posterBackgroundColorHex"
                  :poster-featured-background-color="posterFeaturedBackgroundColor"
                  :poster-featured-background-color-hex="posterFeaturedBackgroundColorHex"
                  :is-featured="isFeatured(movie)"
                  :has-featured-title-class="hasFeaturedTitleClass(movie)"
                  :featured-showing-badges="featuredShowingBadges(movie)"

                  :show-movie-synopsis="showMovieSynopsis"
                  :truncated-movie-synopsis="truncatedMovieSynopsis"
                  :truncated-line-count="truncatedLineCount"
                  :mobile-truncated-line-count="mobileTruncatedLineCount"
                  :show-coming-soon-date="showComingSoonDate"
                  :show-release-date="showReleaseDate"
                  :button-label="buttonLabel"
                  :button-type="buttonType"
                  :button-color="buttonColor"
                  :button-color-hex="buttonColorHex"
                  :button-border-radius="buttonBorderRadius"

                  :is-phone-preview="isPhonePreview"
                  :is-mobile-view="isPhonePreview || $q.screen.lt.sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="type === MOVIE_QUERY_TYPE.MY_LISTS && !loggedIn"
      class="q-my-xl q-mx-md"
    >
      <div class="text-grey-9 text-center text-h5 q-my-xl">
        {{ $t('pages.exploreMovies.signUpForListsPrompt') }}
      </div>
      <div class="row justify-evenly q-mt-lx">
        <q-btn
          size="lg"
          color="secondary"
          :text-color="getTextColor(currentSite.secondaryColor)"
          :label="$t('auth.actions.login')"
          to="/login"
        />
        <q-btn
          size="lg"
          color="primary"
          :text-color="getTextColor(currentSite.primaryColor)"
          :label="$t('auth.actions.signup')"
          to="/register"
        />
      </div>
    </div>
    <div
      v-else-if="movies.loading"
    >
      <q-inner-loading :showing="true" />
    </div>
    <div
      v-else-if="!movies.loading && movies.data.length === 0"
      class="q-py-xl q-mx-md text-center text-h5"
      :class="exploreUsingDarkMode ? 'text-white' : 'text-grey-9'"
    >
      {{ $t('pages.exploreMovies.noMoviesHere') }}
    </div>
    <div
      v-if="(movies.count > movies.data.length) && showLoadMore"
      class="text-center text-subtitle2 q-pa-md"
      :class="exploreUsingDarkMode ? 'text-white' : 'text-grey-7'"
    >
      {{ $t('pages.exploreMovies.moviesCountPrompt', { count: movies.count - movieQuery.length }) }}<br>
      {{ $t('pages.exploreMovies.searchPrompt') }}.<br>
      {{ $t('pages.exploreMovies.searchOptionsPrompt') }}
      <div class="row justify-evenly q-mt-lg">
        <q-btn
          outline
          size="sm"
          color="primary"
          :label="$t('search.actions.search')"
          @click="$refs.search.focus()"
        />
        <q-btn
          outline
          size="sm"
          color="secondary"
          :label="$t('actions.loadMore')"
          @click="limit += 10,overrideLimit += 10"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { date } from 'quasar'
const { formatDate } = date
import i18n from 'src/i18n'
import { IsoDate } from 'src/models/model'
import { MOVIE_QUERY_TYPE } from 'src/models/movie/Movie'
import { EXPLORE_MOVIES_FILTER_TYPES } from 'src/models/page/Section'
import ExplorePoster from 'src/modules/consumer/components/ExplorePoster'
import SectionHeading from 'src/modules/consumer/components/SectionHeading'

const myListDescriptions = {
  watched: i18n.global.t('pages.exploreMovies.watchedDescription'),
  watch_list: i18n.global.t('pages.exploreMovies.watchListDescription'),
  favorite: i18n.global.t('pages.exploreMovies.favoritesDescription'),
  rating: i18n.global.t('pages.exploreMovies.ratingDescription')
}

export default {
  name: 'ExploreMovies',
  components: {
    ExplorePoster,
    SectionHeading
  },
  inject: {
    order: {
      default: null
    }
  },
  props: {
    headingColor: {
      type: String,
      default: 'primary',
      required: false
    },
    headingColorHex: {
      type: String,
      default: '#FFFFFF',
      required: false
    },
    headingAlign: {
      type: String,
      default: null,
      required: false
    },
    headingFontSize: {
      type: String,
      default: null,
      required: false
    },
    headingType: {
      type: String,
      default: 'default',
      required: false
    },
    headingBackgroundImageUrl: {
      type: String,
      default: null,
      required: false
    },
    headingBackgroundImageRepeat: {
      type: Boolean,
      required: false,
      default: true
    },
    widthMode: {
      type: String,
      required: false,
      default: 'Full Width'
    },
    initialType: {
      type: String,
      required: false,
      default: MOVIE_QUERY_TYPE.NOW_PLAYING
    },
    initialUserList: {
      type: String,
      required: false,
      default: 'watched'
    },
    initialDisplayType: {
      type: String,
      required: false,
      default: 'posters'
    },
    filterValue: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    showType: {
      type: Boolean,
      required: false,
      default: true
    },
    showDisplayType: {
      type: Boolean,
      required: false,
      default: true
    },
    showSearch: {
      type: Boolean,
      required: false,
      default: true
    },
    postersPerRow: {
      type: Number,
      required: false,
      default: 8
    },
    mobilePostersPerRow: {
      type: Number,
      required: false,
      default: 3
    },
    posterPadding: {
      type: Number,
      required: false,
      default: 0
    },
    posterBorderRadius: {
      type: Number,
      required: false,
      default: 0
    },
    shadow: {
      type: Number,
      required: false,
      default: 0
    },
    showUserButtons: {
      type: Boolean,
      required: false,
      default: true
    },
    updateUrl: {
      type: Boolean,
      required: false,
      default: true
    },
    initialTitleClassIds: {
      type: Array,
      required: false,
      default: null
    },
    featuredTitleClassIds: {
      type: Array,
      required: false,
      default: null
    },
    featuredShowingBadgeIds: {
      type: Array,
      required: false,
      default: null
    },
    useClassFilter: {
      type: Boolean,
      required: false,
      default: false
    },
    useBanner: {
      type: Boolean,
      required: false,
      default: false
    },
    showTrailerButtonOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    cleanImageOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    exploreUsingDarkMode: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieTitleOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieRating: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieGenre: {
      type: Boolean,
      required: false,
      default: false
    },
    fontSize: {
      type: Number,
      required: false,
      default: 20
    },
    hasTextWrapped: {
      type: Boolean,
      required: false,
      default: true
    },
    hasTextCentred: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieShowingStatusOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    showTitleClass: {
      type: Boolean,
      required: false,
      default: false
    },
    posterBackgroundColor: {
      type: String,
      required: false,
      default: null
    },
    posterBackgroundColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    posterFeaturedBackgroundColor: {
      type: String,
      required: false,
      default: null
    },
    posterFeaturedBackgroundColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    showMovieSynopsis: {
      type: Boolean,
      required: false,
      default: false
    },
    truncatedMovieSynopsis: {
      type: Boolean,
      required: false,
      default: true
    },
    truncatedLineCount: {
      type: Number,
      required: false,
      default: 3
    },
    mobileTruncatedLineCount: {
      type: Number,
      required: false,
      default: 3
    },
    showComingSoonDate: {
      type: Boolean,
      required: false,
      default: true
    },
    showReleaseDate: {
      type: Boolean,
      required: false,
      default: true
    },
    buttonLabel: {
      type: String,
      required: false,
      default: null
    },
    buttonType: {
      type: String,
      required: false,
      default: 'outline'
    },
    buttonColor: {
      type: String,
      required: false,
      default: null
    },
    buttonColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    buttonBorderRadius: {
      type: Number,
      required: false,
      default: 4
    },
    isPhonePreview: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileView: {
      type: Boolean,
      required: false,
      default: false
    },
    showLoadMore: {
      type: Boolean,
      required: false,
      default: true
    },
    overrideLimit: {
      type: Number,
      required: false,
      default: null
    },
    exploreMoviesFilterTypes: {
      type: Object,
      required: false,
      default: () => _(EXPLORE_MOVIES_FILTER_TYPES.ALL).keyBy().mapValues(_ => true).value()
    }
  },
  data () {
    return {
      errorOccurred: false,
      type: this.initialType,
      userList: this.initialUserList,
      displayType: this.initialDisplayType,
      formatDate,
      search: '',
      calendarViewDescend: false,
      limit: 100,
      dragging: false,
      selectedTitleClassId: null,
      titleClassTabs: null,
      hasCustomisedPostersPerRow: !!this.postersPerRow && this.postersPerRow !== 8,
      hasCustomisedMobilePostersPerRow: !!this.mobilePostersPerRow && this.mobilePostersPerRow !== 3
    }
  },
  models: {
    movies: {
      datesWithPublicShowing: 'default',
      variables () {
        return {
          searchString: _.compact([this.filterValue, this.search]).join(' '),
          type: this.type,
          subtype: this.userList,
          orderBy: this.orderBy[0],
          descending: this.orderBy[1],
          limit: this.overrideLimit || this.limit,
          titleClassId: this.selectedTitleClassId,
          titleClassIds: this.initialTitleClassIds,
          siteIds: this.movieQuerySiteIds,
          currentMovieId: this.type === MOVIE_QUERY_TYPE.MORE_FILMS && this.order?.currentShowing?.movie ? this.order.currentShowing.movie.id : null,
          movieIdsToExclude: this.type === MOVIE_QUERY_TYPE.MORE_FILMS ? _.map(this.order.allMovies, movie => movie.id) : null
        }
      }
    }
  },
  configuration: ['titleClasses', 'showingBadges', 'currentSite', 'sites'],
  computed: {
    movieQuery () {
      if (this.currentSite.consumerConfig.showMoviesAndShowingsForMultipleSites) {
        return _.uniqBy(this.movies.data, 'urlSlug')
      }
      return this.movies.data
    },
    movieQuerySiteIds () {
      if (!this.currentSite.consumerConfig.showMoviesAndShowingsForMultipleSites) return []

      const movieQuerySites = _.filter(this.sites.data, site => !site.isLibrary && !site.consumerConfig.hideOnLocationSelectPage)
      return _.map(movieQuerySites, 'id')
    },
    firstShowingDates () {
      let rapped = _(this.movies.data).map(movie => movie.dateOfFirstShowing || this.$i18n.t('common.TBC')).sort().uniqBy(date => _.isDate(date) ? date.format() : date)
      if (this.calendarViewDescend) {
        rapped = rapped.reverse()
      }
      return rapped.value()
    },
    showingDates () {
      let rapped = _(this.moviesByShowingDate).keys().uniq().sort()
      if (this.calendarViewDescend) {
        rapped = rapped.reverse()
      }
      return rapped.value()
    },
    moviesByDateOfFirstShowing () {
      const movies = _.groupBy(this.movies.data, movie => movie.dateOfFirstShowing || this.$i18n.t('common.TBC'))

      if (this.currentSite.moviePageConfig.showMoviesAndShowingsForMultipleSites) {
        // Deduplicate movies by urlSlug for each first showing date
        const deduplicatedMovies = {}
        _.forEach(movies, (moviesForDate, date) => {
          deduplicatedMovies[date] = _.uniqBy(moviesForDate, 'urlSlug')
        })
        return deduplicatedMovies
      }
      return movies
    },
    moviesByShowingDate () {
      const movies = _(this.movies.data).map(movie => {
        return _.map(movie.datesWithPublicShowing, date => [date, movie])
      }).flatten()
        .groupBy(datesAndMovies =>
          datesAndMovies[0]
        )
        .map(dateDatesAndMovies => {
          const dateString = dateDatesAndMovies[0][0]
          const dateInTimeZone = IsoDate.parse(dateString).inTimeZone(this.currentSite?.timeZone).format()
          return [dateInTimeZone, _.map(dateDatesAndMovies, 1)]
        })
        .fromPairs()
        .value()

      if (this.currentSite.moviePageConfig.showMoviesAndShowingsForMultipleSites) {
        // Deduplicate movies by urlSlug for each showing date
        const deduplicatedMovies = {}
        _.forEach(movies, (moviesForDate, date) => {
          deduplicatedMovies[date] = _.uniqBy(moviesForDate, 'urlSlug')
        })
        return deduplicatedMovies
      }
      return movies
    },
    firstLetters () {
      return _(this.movies.data).map('name').map(name => name[0]).uniq().sort().value()
    },
    moviesByFirstLetter () {
      let movies = this.movies.data
      if (this.currentSite.consumerConfig.showMoviesAndShowingsForMultipleSites) {
        movies = _.uniqBy(movies, 'urlSlug')
      }
      return _.groupBy(movies, movie => movie.name[0])
    },
    orderBy () {
      if (this.displayType === 'posters') {
        if (this.type === MOVIE_QUERY_TYPE.NOW_PLAYING_AND_COMING_SOON) {
          return ['magic', false]
        } else if (this.type === MOVIE_QUERY_TYPE.NOW_PLAYING) {
          return ['magic', false]
        } else if (this.type === MOVIE_QUERY_TYPE.COMING_SOON) {
          return ['magic_date_of_first_showing', false]
        } else if (this.type === MOVIE_QUERY_TYPE.MORE_FILMS) {
          return []
        }
      } else if (this.displayType === 'alphabetical') {
        return ['name', false]
      } else if (this.displayType === 'calendar') {
        return ['date_of_first_showing', this.calendarViewDescend]
      } else if (this.displayType === 'showings-calendar') {
        return ['date_of_first_showing', false]
      }

      return ['date_of_first_showing', true]
    },
    minWidth () {
      if (this.hasCustomisedPostersPerRow) {
        // load customised numbers of posters per row
        if (this.displayType === 'posters') {
          if (this.hasCustomisedMobilePostersPerRow) {
            if (this.isMobileView) return 100 / this.mobilePostersPerRow
            if (this.$q.screen.sm) return 100 / this.mobilePostersPerRow
            if (this.$q.screen.md) return 100 / this.postersPerRow
            return 100 / this.postersPerRow
          } else {
            if (this.useBanner) {
              if (this.isMobileView) return 50
              if (this.$q.screen.sm) return 33.33
              if (this.$q.screen.md) return 100 / this.postersPerRow
              return 100 / this.postersPerRow
            } else {
              if (this.isMobileView) return 33.33
              if (this.$q.screen.sm) return 25
              if (this.$q.screen.md) return 100 / this.postersPerRow
              return 100 / this.postersPerRow
            }
          }
        } else {
          if (this.hasCustomisedMobilePostersPerRow) {
            if (this.isMobileView) return 84 / this.mobilePostersPerRow
            if (this.$q.screen.sm) return 92 / this.mobilePostersPerRow
            if (this.$q.screen.md) return 92 / this.postersPerRow
            return 92 / this.postersPerRow
          } else {
            if (this.useBanner) {
              if (this.isMobileView) return 45
              if (this.$q.screen.sm) return 31
              if (this.$q.screen.md) return 92 / this.postersPerRow
              return 92 / this.postersPerRow
            } else {
              if (this.isMobileView) return 31
              if (this.$q.screen.sm) return 24
              if (this.$q.screen.md) return 92 / this.postersPerRow
              return 92 / this.postersPerRow
            }
          }
        }
      } else {
        // load default numbers of posters per row
        if (this.displayType === 'posters') {
          if (this.useBanner) {
            if (this.isMobileView) return 50
            if (this.$q.screen.sm) return 33.33
            if (this.$q.screen.md) return 25
            return 25
          } else {
            if (this.isMobileView) return 33.33
            if (this.$q.screen.sm) return 25
            if (this.$q.screen.md) return 16.66
            return 12.5
          }
        } else {
          if (this.useBanner) {
            if (this.isMobileView) return 45
            if (this.$q.screen.sm) return 31
            if (this.$q.screen.md) return 24
            return 24
          } else {
            if (this.isMobileView) return 31
            if (this.$q.screen.sm) return 24
            if (this.$q.screen.md) return 16.25
            return 11
          }
        }
      }
    },
    loggedIn () {
      return this.currentUser && this.currentUser.isRemote
    },
    exploreMoviesFilterOptions () {
      const filterOptions = []
      if (this.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.NOW_PLAYING]) {
        filterOptions.push({ label: this.$i18n.t('movie.nowPlaying'), value: MOVIE_QUERY_TYPE.NOW_PLAYING })
      }
      if (this.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.COMING_SOON]) {
        filterOptions.push({ label: this.$i18n.t('movie.comingSoon'), value: MOVIE_QUERY_TYPE.COMING_SOON })
      }
      if (this.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.ALL_MOVIES]) {
        filterOptions.push({ label: this.$i18n.t('collection.all'), value: MOVIE_QUERY_TYPE.NOW_PLAYING_AND_COMING_SOON })
      }
      if (this.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.MY_MOVIES]) {
        filterOptions.push({ label: this.$i18n.t('movie.myMovies'), value: MOVIE_QUERY_TYPE.MY_LISTS })
      }
      return filterOptions
    }
  },
  watch: {
    selectedTitleClassId () {
      if (!this.selectedTitleClassId && this.titleClassTabs !== null) {
        this.titleClassTabs = null
      }
    },
    initialUserList () {
      this.userList = this.initialUserList
    },
    initialType () {
      this.type = this.initialType
    },
    initialDisplayType () {
      this.displayType = this.initialDisplayType
    },
    initialTitleClassIds () {
      this.titleClassTabs = _(this.initialTitleClassIds).map(titleClassId => _.find(this.titleClasses.data, ({ id }) => id === titleClassId)).compact().value()
    },
    'movies.data': function () {
      if (this.titleClassTabs || !this.movies.data || !this.movies.data.length) return

      if (this.initialTitleClassIds) {
        this.titleClassTabs = _(this.initialTitleClassIds).map(titleClassId => _.find(this.titleClasses.data, ({ id }) => id === titleClassId)).compact().value()
      } else {
        this.titleClassTabs = _(this.movies.data).map(movie => movie.titleClass).uniq().without(null).sortBy('displayOrder').value()
      }
    }
  },
  created () {
    this.search = this.$route.query['search-string'] || this.search
    this.calendarViewDescend = this.$route.query.descending === 'true' || this.calendarViewDescend
    const selectedTitleClassId = Number(this.$route.query['selected-title-class-id'])

    if (this.initialType) {
      this.type = this.initialType
    } else {
      this.type = this.$route.query.type || this.type
    }
    if (this.initialUserList) {
      this.userList = this.initialUserList
    } else {
      this.userList = this.$route.query['user-list'] || this.userList
    }
    if (this.initialDisplayType) {
      this.displayType = this.initialDisplayType
    } else {
      this.displayType = this.$route.query['display-type'] || this.DisplayType
    }

    if (this.initialTitleClassIds) {
      this.selectedTitleClassId = selectedTitleClassId && this.initialTitleClassIds.includes(selectedTitleClassId) ? selectedTitleClassId : this.selectedTitleClassId
    } else {
      this.selectedTitleClassId = selectedTitleClassId || this.selectedTitleClassId
    }

    _.extend(this, { EXPLORE_MOVIES_FILTER_TYPES, MOVIE_QUERY_TYPE }, { myListDescriptions })
  },
  methods: {
    setDragging (value) {
      // This is used to prevent a click event and need to be delayed until
      // the ui thread processes that click event. Tried $nexttick and did not
      // work. setTimeout works.
      setTimeout(() => {
        this.dragging = value
      })
    },
    featuredShowingBadges (movie) {
      if (!this.featuredShowingBadgeIds) return

      return _.filter(this.showingBadges.data, ({ id, displayName }) => {
        return _.includes(this.featuredShowingBadgeIds, id) && _.includes(movie.displayMetaData?.everyShowingsBadges, displayName)
      })
    },
    hasFeaturedTitleClass (movie) {
      return (!!this.featuredTitleClassIds && _.some(this.featuredTitleClassIds, featuredTitleClassId => featuredTitleClassId === movie.titleClass?.id))
    },
    isFeatured (movie) {
      return (this.featuredShowingBadges(movie) && this.featuredShowingBadges(movie).length > 0) || this.hasFeaturedTitleClass(movie)
    },
    setWidth (movie, minWidth) {
      // featured movie's minWidth 2 time wider than  none feature movie
      if (this.isFeatured(movie)) {
        // featured movie's minWidth are no more than screen width in mobile view
        return minWidth * 2 >= 100 ? '100%' : `${minWidth * 2}%`
      }
      return `${minWidth}%`
    },
    getTextColor (color) {
      return this.$isColorDark(color) ? 'white' : 'black'
    }
  },
  context: ['currentUser']
}
</script>

<style lang="scss" scoped>
.main-display {
  display: flex;
  flex-direction: row;

  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.movie-container.no-background {
  background-color:rgba(150, 150, 150, 0.2);
}

.poster {
  width: 250px;
  max-width: 250px;
  border-radius: 7px;
  margin: 5px;
}
.movie-name {
  max-width: 250px;
  font-size: 18px;
  padding: 7px;
}

.past {
  color: #333;
}
.current {
  color: var(--q-primary);
}

.message {
  font-size: 32px;
  text-align: center;
}

.heading {
  margin-left: auto;
  margin-right: auto;
}

h2 {
  // background: rgba(33,33,33,.4);
  min-width: unset !important;
  padding: 0 5px;

  color: var(--q-primary);
  font-size: 18px;
  font-weight: bold;
  line-height: 1em;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.group-section:nth-child(odd) {
  background-color:rgba(150, 150, 150, 0.2);
}

.group-section:nth-child(even) {
  background-color:rgba(150, 150, 150, 0.1);
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
}
.list-complete-enter {
  opacity: 0;
  transform: translateY(50vh);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(100vh) translateX(25vw);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
